import React from 'react'
import { Grid} from '@material-ui/core'
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome'

const StepIcon = props => {
    const getIconClassName = () => {
        let StepICon = 'lock-alt'
        if (props.active) StepICon = 'pen'
        else if (props.completed) StepICon = 'check'
        return StepICon
    }
    return (
        <Grid className={`step-icon__container ${getIconClassName()}`}>
            <FontAwesomeIcon icon={['far', getIconClassName()]}></FontAwesomeIcon>
        </Grid>
    )
}
export default StepIcon